import styled from 'styled-components';

import { Colour } from '@xemplo/style-constants';
import { XemploInput } from '@xemplo/xemplo-input';

import { NumberFieldSize } from './number-field.types';

/** Hides spinner buttons on all browsers for number inputs */
export const CustomXemploInput = styled(XemploInput)`
  > input[type='number'] {
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    appearance: textfield;
  }
`;

/**
 * The arrow container needs a negative margin
 * to avoid using position absolute, which creates
 * some complications setting the input position
 */
export const ArrowSteps = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: -16px;

  svg {
    color: var(--input-trailing-icon-color);
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 48px;
  outline: none;

  &.${NumberFieldSize.Spacious} {
    height: 28px;
  }

  &.${NumberFieldSize.Default} {
    height: 20px;
  }

  &.${NumberFieldSize.Compact} {
    height: 16px;
  }

  &.arrow-up {
    padding-top: 4px;
  }

  &.arrow-down {
    padding-bottom: 4px;
  }

  &:active {
    svg {
      color: ${Colour.Gray[600]};
    }
  }
`;
